import { BookOpenCheckIcon, FactoryIcon, NetworkIcon, SearchCheckIcon, ShieldCheckIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Industrial Automation & PLC Technical Glossary',
    description: '150 essential automation, control, and systems terms explained.',
    icon: BookOpenCheckIcon,
  },
  {
    number: '2',
    title: 'PLC Troubleshooting & Fault Analysis Reference',
    description: '48 industrial fault scenarios with technical analysis.',
    icon: SearchCheckIcon,
  },
  {
    number: '3',
    title: 'Industrial Control Systems Explained',
    description: '30 practical industrial scenarios with control system concepts.',
    icon: FactoryIcon,
  },
  {
    number: '4',
    title: 'PLC Logic, Signals & Control Concepts Companion',
    description: '40 technical concept connections + 4 integration maps.',
    icon: NetworkIcon,
  },
  {
    number: '5',
    title: 'Industrial Automation Safety & Reliability Handbook',
    description: '36 essential safety and reliability principles + 6 industrial scenarios.',
    icon: ShieldCheckIcon,
  },
];
